import { RestApiForm } from '../../tasks/types';
import { Instruction } from '../use-form-fields';
import { basicIssue, basicTask } from './instructions';

const formFieldInstructions = (form: RestApiForm): Instruction[] | undefined => {
  switch (form?.system_type) {
    case 'basic_task':
      return basicTask;
    case 'basic_issue':
      return basicIssue;
    default:
      return undefined;
  }
};

export default formFieldInstructions;
